export default __webpack_public_path__ + "static/media/mountain_ash.af325d16.jpeg";